import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=47b5bb78&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b5bb78')) {
      api.createRecord('47b5bb78', component.options)
    } else {
      api.reload('47b5bb78', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=47b5bb78&", function () {
      api.rerender('47b5bb78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/UserFilters/Table.vue"
export default component.exports